//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2025, 2026. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//
import React, { createContext, useContext } from 'react';

const AnnouncementOffsetContext = createContext<number>(0);

interface AnnouncementOffsetProviderProps {
  value: number;
  children: React.ReactNode;
}

export const AnnouncementOffsetProvider: React.FC<
  AnnouncementOffsetProviderProps
> = ({ value, children }) => (
  <AnnouncementOffsetContext.Provider value={value}>
    {children}
  </AnnouncementOffsetContext.Provider>
);

export const useAnnouncementOffset = () =>
  useContext(AnnouncementOffsetContext);

export { AnnouncementOffsetContext };
